<div
  class="lang-preview flex-center"
  role="button"
  nz-dropdown
  nzTrigger="click"
  nzPlacement="bottomRight"
  [nzDropdownMenu]="langMenu">
  <img [src]="getLangIcon()" class="lang-icon" alt="Language" />
</div>

<nz-dropdown-menu #langMenu="nzDropdownMenu">
  <ul nz-menu class="lang-dropdown">
    <li nz-menu-item role="button" (click)="selectLanguage('en')">
      <img src="/assets/icons/en.png" class="lang-icon" alt="English" />
      English
    </li>
    <li nz-menu-item (click)="selectLanguage('es')">
      <img src="/assets/icons/es.png" class="lang-icon" alt="Spanish" />
      Spanish
    </li>
  </ul>
</nz-dropdown-menu>
